// ========================================
// ⚠️ NOTIFICATION CONFIRMATION - TEMPORALMENTE OCULTO
// ========================================
// Componente comentado para desarrollo futuro
// Fecha de ocultación: 2025-11-17
// Para reactivar: Descomentar el código a continuación
// ========================================

/*
import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const NotificationConfirmation = ({ userData, transactionData }) => {
  const [emailSent, setEmailSent] = useState(false);
  const [whatsappSent, setWhatsappSent] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate notification sending
    const timer = setTimeout(() => {
      setEmailSent(true);
      setWhatsappSent(true);
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const notifications = [
    {
      type: 'email',
      icon: 'Mail',
      title: 'Confirmación por Email',
      description: `Enviado a ${userData?.email}`,
      sent: emailSent,
      color: 'text-secondary'
    },
    {
      type: 'whatsapp',
      icon: 'MessageCircle',
      title: 'Notificación WhatsApp',
      description: `Enviado a ${userData?.phone}`,
      sent: whatsappSent,
      color: 'text-success'
    }
  ];

  if (isLoading) {
    return (
      <div className="bg-card rounded-xl border border-border p-6 shadow-luxury">
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-8 h-8 bg-secondary/10 rounded-lg flex items-center justify-center">
            <Icon name="Send" size={16} className="text-secondary" />
          </div>
          <h3 className="text-lg font-heading font-bold text-gray-800">
            Enviando Notificaciones
          </h3>
        </div>
        <div className="space-y-3">
          {notifications?.map((notification, index) => (
            <div key={index} className="flex items-center space-x-3 p-3 bg-muted/20 rounded-lg">
              <div className="animate-spin">
                <Icon name="RefreshCw" size={16} className="text-gray-800" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-800">
                  {notification?.title}
                </p>
                <p className="text-xs text-gray-800">
                  Enviando...
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl border border-border p-6 shadow-luxury">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center">
          <Icon name="CheckCircle" size={16} className="text-success" />
        </div>
        <h3 className="text-lg font-heading font-bold text-gray-800">
          Notificaciones Enviadas
        </h3>
      </div>
      <div className="space-y-4">
        {notifications?.map((notification, index) => (
          <div key={index} className="flex items-center space-x-4 p-4 bg-muted/10 rounded-lg border border-border">
            <div className={`w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center`}>
              <Icon name={notification?.icon} size={18} className={notification?.color} />
            </div>
            
            <div className="flex-1">
              <div className="flex items-center space-x-2 mb-1">
                <h4 className="font-body font-semibold text-gray-800">
                  {notification?.title}
                </h4>
                <Icon name="CheckCircle" size={14} className="text-success" />
              </div>
              <p className="text-sm text-gray-800 font-caption">
                {notification?.description}
              </p>
            </div>

            <div className="text-right">
              <div className="flex items-center space-x-1 text-success">
                <Icon name="Check" size={14} />
                <span className="text-xs font-medium text-gray-800">
                  Enviado
                </span>
              </div>
              <p className="text-xs text-gray-800 mt-1">
                {new Date()?.toLocaleTimeString('es-VE', {
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center space-x-2 text-sm">
          <Icon name="Info" size={14} className="text-gray-800" />
          <span className="text-gray-800 font-caption">
            Las notificaciones incluyen detalles de la transacción y próximos pasos
          </span>
        </div>
      </div>
    </div>
  );
};

export default NotificationConfirmation;
*/

// Componente placeholder (no exporta nada funcional)
const NotificationConfirmation = () => null;
export default NotificationConfirmation;
